import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Typography } from '@mui/material';
import { MessageBox } from 'shared/components/dialogs/message-box';
import { useMemo, useState } from 'react';
import { useBooleanState } from 'shared/hooks/state/boolean';
export const useGraphDeleteDialog = () => {
    const [opened, close, open] = useBooleanState(false);
    const [local_block, setBlock] = useState(undefined);
    const _open = (block) => {
        open();
        setBlock(block);
    };
    const GraphDeleteDialog = useMemo(() => {
        const GraphDeleteDialogComponent = ({ children, onConfirm, onReject, ...props }) => {
            const _onReject = onReject != null ? onReject : close;
            const _onConfirm = () => {
                if (local_block)
                    onConfirm(local_block);
                close();
            };
            return (_jsx(MessageBox, { open: opened, onClose: close, isError: true, footer: _jsxs(_Fragment, { children: [_jsx(Button, { onClick: _onReject, color: "neutral", children: "\u041E\u0442\u043C\u0435\u043D\u0430" }), _jsx(Button, { color: "error", onClick: _onConfirm, children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" })] }), ...props, children: _jsx(Typography, { variant: "subtitle1", color: "error", sx: { maxWidth: '300px' }, children: "\u0412\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0433\u0440\u0430\u0444\u0438\u043A?" }) }));
        };
        return GraphDeleteDialogComponent;
    }, [opened, close, local_block]);
    return [GraphDeleteDialog, _open];
};
